/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.24",
    versionName: "0.4.0-nightly.2026.6.24",
    versionChannel: "nightly",
    buildDate: "2026-06-24T00:33:56.491Z",
    commitHash: "d39d416c31fe9530857de0eda922baca3f807aa6",
};
